import logo from "./common/logo.webp";
import homeactive from "./common/homeactive.png";
import homeinactive from "./common/homeinactive.png";
import footerLogo from "./common/footerlogo.webp";
import loginbannerlogo from "./common/loginbannerlogo.webp";
import pcmlogo from "./common/PCM.png";
import downloadhand from "./common/downloadhand.png";
import dummyorderimg from "./common/dummyorderimg.webp";
import footerbanner from "./common/footerbanner2.jpg";
import locationvector from "./common/locationvector.webp";
import loginbanner from "./common/Login.webp";
import newloginbanner from "./common/newloginbanner.png";
import loginvector from "./common/loginvector.webp";
import noordervector from "./common/noordervector.webp";
import playstore from "./common/playstore.webp";
import qr from "./common/qr.jpg";
import heroNonAuthBanner from "./common/BannerNonAuth.webp";
import requirementsbanner from "./common/requirementsbanner.webp";
import loginvectormobile from "./common/loginvectormobile.png";
import loginvectormobile2 from "./common/loginvectormobile2.png";
import loginvectormobile3 from "./common/loginvectormobile3.png";
import frame from "./common/frame.png";
import location from "./common/location.gif";
import frame1 from "./common/fram1.png";
import frame2 from "./common/frame2.png";
import qqtlogo from "./common/qqtlogo.png";
import qqtdark from "./common/qqtdark.png";
import callusvector from "./home/callusvector.webp";
import categoryimg1 from "./home/categoryimg1.webp";
import categoryimg2 from "./home/categoryimg2.webp";
import categoryimg3 from "./home/categoryimg3.webp";
import categoryimg4 from "./home/categoryimg4.webp";
import categoryimg5 from "./home/categoryimg5.webp";
import categoryimg6 from "./home/categoryimg6.webp";
import comaicon from "./home/comaicon.webp";
import herobanner from "./home/herobanner.webp";
import herobannernew from "./home/herobannernew.png";
import homevector from "./home/homevector.webp";
import homevector2 from "./home/homevector2.webp";
import salebanner from "./home/salebanner.webp";
import salebanner3 from "./home/salebanner3.webp";
import salebanner2 from "./home/salebanner2.webp";
import qnavector from "./home/qnavector.webp";
import bannerImg from "./home/homebannernew2.jpg";
import herobannerphone from "./home/homenewbannermobile.jpeg";

export const assets = {
  logo,
  pcmlogo,
  frame1,
  frame2,
  qqtlogo,
  qqtdark,
  location,
  frame,
  homeactive,
  homeinactive,
  loginvectormobile,
  loginvectormobile2,
  loginvectormobile3,
  footerLogo,
  downloadhand,
  dummyorderimg,
  footerbanner,
  locationvector,
  loginbanner,
  newloginbanner,
  loginbannerlogo,
  loginvector,
  noordervector,
  playstore,
  qr,
  heroNonAuthBanner,
  qnavector,
  requirementsbanner,
  callusvector,
  categoryimg1,
  categoryimg2,
  categoryimg3,
  categoryimg4,
  categoryimg5,
  categoryimg6,
  comaicon,
  herobanner,
  homevector,
  homevector2,
  salebanner,
  salebanner2,
  salebanner3,
  bannerImg,
  herobannerphone,
  herobannernew,
};
